import { ITagsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class AddTagsToPublishedConnectionsRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToPublishedConnections', {
      ids: ids,
      tags: tags
    });
  }
}
